import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import HomePage from "./pages/HomePage";
import PaymentFailedPage from "./pages/PaymentFailedPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import RegistrationPage from "./pages/RegistrationPage";
import RazorpayPaymentPage from "./pages/RazorpayPaymentPage";
import OptionsPage from "./pages/OptionsPage";
import ExamDetailPage from "./pages/ExamDetailPage";
import ExamDetailPageOption2 from "./pages/ExamDetailPageOption2";
import ExamDetailPageOption3 from "./pages/ExamDetailPageOption3";
import TermsandConditions from "./pages/TermsandConditions";
import INDRegistrationPage from "./pages/IND_REGISTER/INDRegistrationPage";
import INDRegistrationPagesm from "./pages/IND_REGISTER/INDRegistrationPagesm";
import InternationalRegistrationPage from "./pages/INTERNATIONAL_REGISTER/InternationalRegistrationPage";
import ExamDetailPageInt from "./pages/INTERNATIONAL_REGISTER/ExamDetailPageInt";
import ExamDetailPageIntOption2 from "./pages/INTERNATIONAL_REGISTER/ExamDetailPageIntOption2";
import ExamDetailPageIntOption3 from "./pages/INTERNATIONAL_REGISTER/ExamDetailPageIntOption3";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/register" element={<RegistrationPage />} /> */}
          {/* <Route path="/register/india" element={<INDRegistrationPage />} /> */}
          <Route path="/indregister" element={<INDRegistrationPage />} />
          <Route path="/options-sm" element={<INDRegistrationPagesm />} />
          <Route path="/register/international" element={<InternationalRegistrationPage />} />
          <Route path="/register/payment" element={<RazorpayPaymentPage />} />
          <Route path="/register/payment/failed" element={<PaymentFailedPage />} />
          <Route path="/register/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment-failure" element={<PaymentFailedPage />} />
          <Route path="/payment-success" element={<PaymentSuccessPage />} />
          <Route path="/terms-and-conditions" element={<TermsandConditions />} />
          <Route path="/options" element={<OptionsPage />} />
          <Route path="/exam/:examId" element={<ExamDetailPage />} />
          <Route path="/exam/:examId/option-2" element={<ExamDetailPageOption2 />} />
          <Route path="/exam/:examId/option-3" element={<ExamDetailPageOption3 />} />
          <Route path="/international-exam/:examId" element={<ExamDetailPageInt />} />
          <Route path="/international-exam/:examId/option-2" element={<ExamDetailPageIntOption2 />} />
          <Route path="/international-exam/:examId/option-3" element={<ExamDetailPageIntOption3 />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
